import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
import { getCheckoutUrl } from '../../utils/checkoutUrl';
export function FloatingCTA({
  totalPrice = 17.27,
  bump1 = false,
  bump2 = false
}: {
  totalPrice?: number;
  bump1?: boolean;
  bump2?: boolean;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const hasExtras = totalPrice > 17.27;
  const checkoutUrl = getCheckoutUrl(bump1, bump2);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.8;
      setIsVisible(window.scrollY > heroHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-45">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50" role="complementary" aria-label="Comprar ahora" data-id="element-46">
          <div className="backdrop-blur-md border-t px-4 py-3 sm:py-4" style={{
        backgroundColor: 'rgba(11, 26, 46, 0.92)',
        borderColor: 'rgba(212, 160, 23, 0.25)'
      }} data-id="element-47">
            <div className="max-w-2xl mx-auto flex items-center justify-between gap-4" data-id="element-48">
              <div className="hidden sm:block" data-id="element-49">
                <p className="font-serif-display font-bold text-lg" style={{
              color: '#FAF3E8'
            }} data-id="element-50">
                  El Método Express
                </p>
                <p className="text-sm" style={{
              color: 'rgba(250, 243, 232, 0.6)'
            }} data-id="element-51">
                  7 Arreglos que Pagan la Renta
                </p>
              </div>
              <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-52">
                <div className="flex items-center gap-2" data-id="element-53">
                  <AnimatePresence mode="wait" data-id="element-54">
                    {hasExtras ? <motion.span key="base" initial={{
                  opacity: 0,
                  x: -6
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: -6
                }} className="font-body text-sm line-through" style={{
                  color: 'rgba(250, 243, 232, 0.35)'
                }} data-id="element-55">
                        $17.27
                      </motion.span> : <motion.span key="original" initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} exit={{
                  opacity: 0
                }} className="font-body text-base line-through" style={{
                  color: 'rgba(250, 243, 232, 0.4)'
                }} data-id="element-56">
                        $27
                      </motion.span>}
                  </AnimatePresence>

                  <AnimatePresence mode="wait" data-id="element-57">
                    <motion.span key={totalPrice} initial={{
                  scale: 1.1,
                  color: '#FFD700'
                }} animate={{
                  scale: 1,
                  color: '#D4A017'
                }} transition={{
                  duration: 0.3
                }} className="font-serif-display font-bold text-2xl sm:text-3xl" data-id="element-58">
                      ${totalPrice.toFixed(2)}
                    </motion.span>
                  </AnimatePresence>

                  <span className="hidden sm:inline-block px-1.5 py-0.5 rounded text-xs font-bold" style={{
                backgroundColor: '#C0392B',
                color: '#fff'
              }} data-id="element-59">
                    -36%
                  </span>
                </div>
                <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="cta-glow flex-1 sm:flex-none inline-flex items-center justify-center px-6 py-3 rounded-lg font-bold text-base transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
              backgroundColor: '#D4A017',
              color: '#1A1A1A'
            }} aria-label={`Descarga el Método Express por $${totalPrice.toFixed(2)}`} data-id="element-60">
                  Descargar Ahora
                </a>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}